export default "__VITE_ASSET__CRWceZVH__"